<div class="d-block row-cols-12 p-0 w-100">
  <div class="d-block sourceHeader float-start" [ngClass]="{'col-12': detailsCollapsed, 'col-8': !detailsCollapsed}">
    @if (canGoBack) {
      <span class="col-2 float-start p-2 pe-0 pe-3">
        <button type="button" (click)="pageUp()" class="btn btn-sm btn-secondary" [disabled]="isNavigating">
          <i class="bi bi-chevron-left bi-large"></i>
        </button>
      </span>
    }
    <span class="col-2 float-end p-2 pe-0 pe-3">
      <button type="button" (click)="toggleView()" class="btn btn-sm btn-secondary float-end" [disabled]="isNavigating">
        @if (selectedViewType === sourceviewsEnum.List) {
          <i class="bi bi-grid bi-large"></i>
        }
        @if (selectedViewType === sourceviewsEnum.Grid) {
          <i class="bi bi-list-task bi-large"></i>
        }
      </button>
    </span>
  </div>
</div>

<div class="row-cols-12 float-start" [ngClass]="{'col-12': detailsCollapsed, 'col-8': !detailsCollapsed}">
  <div class="ms-0 cloudSource">
    <div class="cloudData">
      <div class="col-12" [ngClass]="{'p-2': selectedViewType === sourceviewsEnum.Grid, 'p-0': selectedViewType !== sourceviewsEnum.Grid}">
        @if (isNavigating) {
          <div class="d-flex align-items-center justify-content-center w-100 h-100">
            <div class="spinner-border text-primary" role="status"></div>
          </div>
        }

        @if (!isNavigating && selectedViewType === sourceviewsEnum.List) {
          <app-cloud-document-file-list></app-cloud-document-file-list>
        }

        @if (!isNavigating && selectedViewType === sourceviewsEnum.Grid) {
          <app-cloud-document-file-grid></app-cloud-document-file-grid>
        }
      </div>

      @if (detailsCollapsed) {
        <div class="col-12 exportImportRow">
          <span class="float-end">
            @if (isExportMode) {
              <button class="btn btn-sm btn-primary m-2"
                (click)="export()"
                [disabled]="isExportDisabled"
                translate="Button.Export">
              </button>
            }
            @if (!isExportMode) {
              <button class="btn btn-sm btn-primary m-2"
                (click)="import()"
                [disabled]="!hasSelectedFiles"
                translate="Button.Import">
              </button>
            }
          </span>
        </div>
      }
    </div>
  </div>
</div>
